<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="success"
        text
        v-on="on"
        v-bind="attrs"
        rounded
        min-width="130"
        @click="emitirPedido()"
        :loading="emitindo"
        >Sim, emitir</v-btn
      >
    </template>
    <v-card>
      <v-card-text class="pt-5">
        <v-layout align-center justify-center column fill-height>
          <template v-if="emitindo">
            <v-row>
              <v-col>
                <v-progress-circular
                  color="primary"
                  size="60"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p class="title">Emitindo pedido...</p>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-alert v-if="erro" text type="error" class="subtitle-1 mt-2">{{
              msgErro
            }}</v-alert>

            <template v-else>
              <v-icon size="45" color="success">mdi-check</v-icon>
              <p class="title text-center">{{ pedidoSalvo.msg }}</p>
              <p class="subtitle-2 mb-1 text-center">{{ pedidoSalvo.outrasmsg }}</p>
              <btn-imprimir-pedido :pedido="pedidoSalvo" />
              <span class="mb-5"></span>
            </template>
          </template>
          <v-btn rounded text @click="fecharDialog()" :disabled="emitindo" block>Fechar</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import BtnImprimirPedido from "../../central-pedidos/BtnImprimirPedido.vue";
import { savePedidosDB } from "@/db/pedidos";
import moment from "moment";

export default {
  components: { BtnImprimirPedido },
  computed: {
    ...mapState("pedidos", ["novopedido", "config"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    dialog: false,
    emitindo: false,
    erro: false,
    msgErro: "",
    pedidoSalvo: {
      id: 0,
      msg: 0,
      outrasmsg: "",
    },
  }),
  methods: {
    ...mapActions("pedidos", ["limparProdutosPendentes", "salvarPedido"]),
    ...mapGetters("pedidos", [
      "clienteBloqueado",
      "getCondicaoSelecionada",
      "getParcelas",
      "getContaSelecionada",
      "getTipoPedidoSelec",
      "validarEmissaoPedido",
    ]),
    async emitirPedido() {
      this.emitindo = true;
      var validarPedido = await this.validarEmissaoPedido();
      if (validarPedido.erro) {
        this.erro = true;
        this.msgErro = validarPedido.msg;
        this.emitindo = false;
        return;
      }

      this.novopedido.usuario = this.usuarioLogado;
      this.novopedido.parcelas = this.getParcelas();
      this.novopedido.conta = this.getContaSelecionada();
      this.novopedido.condicaopgto = {
        codigo: this.getCondicaoSelecionada().codigo,
        condicao: this.getCondicaoSelecionada().condicao,
      };
      this.novopedido.tipopedido = this.getTipoPedidoSelec();
      this.novopedido.datahoraemissao = moment().format();
      this.novopedido.datahoravalidade = moment()
        .add(this.config.validadepedido, "h")
        .format();

      
      this.erro = false;
      this.msgErro = "";
      this.pedidoSalvo.msg = "";
      this.pedidoSalvo.id = 0;
      this.pedidoSalvo.outrasmsg = "";

      if (navigator.onLine) {
        this.pedidoSalvo = await this.salvarPedido();
      } else {
        try {
          this.novopedido.validade = moment()
            .add(this.config.validadepedido, "h")
            .format();
          this.pedidoSalvo.id = await savePedidosDB(this.novopedido,"pedidos");
          if (this.pedidoSalvo.id > 0) {
            this.novopedido.emitiupedido = true;
            this.pedidoSalvo.msg = "Pedido emitido OFFLINE";
            this.pedidoSalvo.outrasmsg =
              "Lembre-se de sincronizar assim que possível!";
          }
        } catch (e) {
          this.erro = true;
          this.msgErro = `Este erro impediu de salvar o pedido: ${e}`;
        }
      }

      this.emitindo = false;
    },
    fecharDialog() {
      if (this.pedidoSalvo.id > 0) {
        this.$router.go();
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>

<style>
</style>
